import { CanvasErrorCodes, ErrorCodes } from '../errorCode';

/** canvas 接口无权限访问时应跳转离开页面的业务错误码。 */
const CANVAS_ACCESS_DENIED_ERROR_CODES = new Set<number>([
  ErrorCodes.AUTH_EXPIRED,
  ErrorCodes.ROOM_ACCESS_DENIED,
  CanvasErrorCodes.LOGIN_EXPIRED,
  CanvasErrorCodes.DEFAULT_ERROR,
  CanvasErrorCodes.SHARE_CLOSE,
  CanvasErrorCodes.ROOM_ACCESS_NOT_MATCH,
  CanvasErrorCodes.TEAM_MEMBER_REMOVED,
]);

/**
 * 从 canvas 请求 reject / axios 错误 / 业务 response 中解析 code。
 */
export function getCanvasResponseErrorCode(error: unknown): number | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const record = error as {
    data?: { code?: unknown; };
    response?: { data?: { code?: unknown; }; status?: number; };
    status?: number;
  };
  const rawCode = record.data?.code ?? record.response?.data?.code;
  if (rawCode != null && !Number.isNaN(Number(rawCode))) {
    return Number(rawCode);
  }
  const httpStatus = record.response?.status ?? record.status;
  if (httpStatus === 400) {
    return CanvasErrorCodes.DEFAULT_ERROR;
  }
  return undefined;
}

/**
 * 判断 canvas 请求是否因无权限 / 访问不匹配而失败。
 */
export function isCanvasAccessDeniedError(error: unknown): boolean {
  const code = getCanvasResponseErrorCode(error);
  return code != null && CANVAS_ACCESS_DENIED_ERROR_CODES.has(code);
}
